import { Col, Input, Radio, Row, Select } from 'antd';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { renderRowCountry } from './../../../../../components/render-select';

const RadioGroup = Radio.Group;

class ShipTo extends Component {
    render() {
        let showPostalCode = true
        const { shipment } = this.props

        if(shipment.ConsigneePostalCodeCH == ''){
            showPostalCode = false
        }
        return (
            <Col span={16} id={shipment.HandlingCharge && shipment.CollectAmount ? "ship-to-extend": "ship-to"}>
                <Row gutter={16}>
                    <Col span={4}>
                        <h1 className='title'>Ship to</h1>
                    </Col>
                    <Col span={10}>
                        <Row gutter={16}>
                            <Col span={12}>
                                <div className="customer title">
                                    <h3 className='title-field'>Customer #</h3>
                                    <Input
                                        disabled
                                    />
                                </div>
                            </Col>
                            <Col span={12}>
                                <div className="channel-customer title">
                                    <h3 className='title-field'>Channel Customer #</h3>
                                    <Input
                                        value={shipment.ChannelCustomerID ? shipment.ChannelCustomerID : ''}
                                        disabled
                                    />
                                </div>
                            </Col>
                        </Row>
                        <Row gutter={16}>
                            <Col span={24}>
                                <div className="name title">
                                    <h3 className='title-field'>NAME</h3>
                                    <Input
                                        value={shipment.ConsigneeNameCH}
                                        disabled
                                    />
                                </div>
                                <div className="phone title">
                                    <h3 className='title-field'>NAME IN ALPHABET</h3>
                                    <Input
                                        type="text"
                                        value={shipment.ConsigneeKanaNameCH}
                                        disabled
                                    />
                                </div>
                                <div className="phone title">
                                    <h3 className='title-field'>PHONE</h3>
                                    <Input
                                        value={shipment.ConsigneePhoneCH}
                                        disabled
                                    />
                                </div>
                                <div className="email title">
                                    <h3 className='title-field'>EMAIL</h3>
                                    <Input
                                        type="email"
                                        value={shipment.ConsigneeEmailCH}
                                        disabled
                                    />
                                </div>
                            </Col>
                        </Row>
                    </Col>
                    <Col span={10}>
                        <Row gutter={16}>
                            <Col span={12}>
                                <div className="gutter-box">
                                    <h3 className='title-field'>COUNTRY</h3>
                                    <Select
                                        style={{ width: '100%' }}
                                        disabled
                                        value={shipment.DestinationCountryCH}
                                    >
                                        {renderRowCountry()}
                                    </Select>
                                </div>
                            </Col>
                            {showPostalCode ?
                                <Col span={12}>
                                    <div className="postal-code title">
                                        <h3 className='title-field'>POSTAL CODE</h3>
                                        <Input
                                            type="text"
                                            className="postal-code"
                                            maxLength={7}
                                            value={shipment.ConsigneePostalCodeCH}
                                            disabled
                                        />
                                    </div>
                                </Col> : ""
                            }
                        </Row>
                        <Row gutter={16}>
                            <Col span={24}>
                                <div className="address1 title">
                                    <h3 className='title-field'>ADDRESS1</h3>
                                    <Input
                                        type="text"
                                        value={shipment.ConsigneeAddress1CH}
                                        disabled
                                        maxLength={100}
                                    />
                                </div>
                                <div className="address2 title">
                                    <h3 className='title-field'>ADDRESS2</h3>
                                    <Input
                                        type="text"
                                        value={shipment.ConsigneeAddress2CH}
                                        disabled
                                        maxLength={100}
                                    />
                                </div>
                                <div className="address3 title">
                                    <h3 className='title-field'>ADDRESS3</h3>
                                    <Input
                                        type="text"
                                        value={shipment.ConsigneeAddress3CH}
                                        disabled
                                        maxLength={100}
                                    />
                                </div>
                                <div className="address4 title">
                                    <h3 className='title-field'>ADDRESS4</h3>
                                    <Input
                                        type="text"
                                        value={shipment.ConsigneeAddress4CH}
                                        disabled
                                        maxLength={100}
                                    />
                                </div>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </Col>
        );
    }
}

const mapStateToProps = state => {
    return {
        shipment: state.detailShipment.shipment
    }
}

export default connect(
    mapStateToProps
)(ShipTo)



// WEBPACK FOOTER //
// ./src/containers/shipments/detail-shipment/components/ship-to/index.js